import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { ApplicationView, useApplicationView } from "@hooks/useApplicationView";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { FC } from "react";
import { ActiveOrganizationAvatar } from "@components/avatar/ActiveOrganizationAvatar";
import styles from "./OrganizationHeader.module.scss";

export const OrganizationHeader: FC = () => {
    const view = useApplicationView();
    const navigate = useStateAwareNavigate();
    const organization = useActiveOrganization();

    if (view !== ApplicationView.MAIN || !organization) {
        return null;
    }

    return (
        <aside className={styles.organizationHeader}>
            <button
                className={styles.organizationLink}
                onClick={() => navigate("/clients")}
                aria-label={`Return to ${organization.name} overview`}
            >
                <span className={styles.organizationLinkText}>
                    Back to <ActiveOrganizationAvatar size="xs" aria-hidden />{" "}
                    {organization.name}
                </span>
            </button>
        </aside>
    );
};
